import { CodeStatus, PermitCategory, PermitType, SignatureType } from "../../common/enums";
import { formElement } from "../forms/FormElement";
import CoordinationPermitFormState from "../forms/Permits/CoordinationPermitFormState";
import Person, { Person_toFormElement } from "../Person";
import Position, { Position_toPositionPickerRow } from "../Position";
import Signature, { Signature_normalize } from "../Signature";
import { permitContentVersions } from "../WorkPermit";

type CoordinationPermit = {
    id: string;
    entityId: number;
    description: string;
    status: CodeStatus;
    positions: Position[];
    sequenceIdentifier: string;
    permitName: PermitType.CoordinationPermit;
    createdByUserName: string;
    version: number;
    hasAttachedFile: boolean;
    referenceNr: string;
    startDate: Date;
    endDate: Date;
    permitCategory: PermitCategory;
    departmentId: number;

    entrepreneur: string;
    entrepreneurContactPersonEmail: string;
    entrepreneurContactPerson: Person;

    permitProviderSignature: Signature;

    company: string;
    companyContactPersonEmail: string;
    companyContactPerson: Person;

    ghabInformsCompanies: string;
    senderInformsCompanies: string;
    informPerformer: boolean;
    workCloseToNeighbours: boolean;

    contentVersion: number;

    canUpdate: boolean;
    canAccept: boolean;
    canCheckout: boolean;
    canManageAttachments: boolean;
    canManagePositionActiveStatus: boolean;
    canManagePositionPolygons: boolean;

    rejectionComment: string;
};

export default CoordinationPermit;

export function CoordinationPermit_normalize(permit: CoordinationPermit): CoordinationPermit {
    const normalizedPermit: CoordinationPermit = {
        ...permit,
        startDate: new Date(permit.startDate),
        endDate: new Date(permit.endDate),
        permitProviderSignature: Signature_normalize(permit.permitProviderSignature, SignatureType.PermitProvider),
        contentVersion: permit.contentVersion ?? Math.max(...Object.values(permitContentVersions))
    };

    return normalizedPermit;
}

export function CoordinationPermit_toFormState(permit: CoordinationPermit): CoordinationPermitFormState {
    const formState: CoordinationPermitFormState = {
        company: formElement(permit.company),
        companyContactPersonEmail: formElement(permit.companyContactPersonEmail),
        description: formElement(permit.description),
        endDate: formElement(permit.endDate),
        entrepreneur: formElement(permit.entrepreneur),
        entrepreneurContactPerson: Person_toFormElement(permit.entrepreneurContactPerson),
        entrepreneurContactPersonEmail: formElement(permit.entrepreneurContactPersonEmail),
        ghabInformsCompanies: formElement(permit.ghabInformsCompanies),
        informPerformer: formElement(permit.informPerformer),
        positions: permit.positions.map(Position_toPositionPickerRow),
        referenceNr: formElement(permit.referenceNr),
        senderInformsCompanies: formElement(permit.senderInformsCompanies),
        startDate: formElement(permit.startDate),
        workCloseToNeighbours: formElement(permit.workCloseToNeighbours),
        permitCategory: formElement(permit.permitCategory),
        companyContactPerson: Person_toFormElement(permit.companyContactPerson),
        expirationReminderEmail: formElement(""),
        expirationReminderPhoneNumber: formElement(""),
        remindMe: formElement(false),
        remindMeDate: formElement(new Date()),
    };

    return formState
}
